import sjcl from 'sjcl';

export default class SjclManager {
  static ITER = 1000;
  static ALG = "gcm";
  static TS = 128;
  static KS = 256;

  static doEncrypt(password, v_adata, plaintext) {
    var iv = [];
    var key = [];
    var rp = {};
    if (plaintext === "") {
      return "";
    }
    if (key.length == 0 && password.length == 0) {
      return "";
    }
    var p = {
      adata: v_adata,
      iter: SjclManager.ITER,
      mode: SjclManager.ALG,
      ts: parseInt(SjclManager.TS),
      ks: parseInt(SjclManager.KS)
    };
    var ctJson = sjcl.encrypt(password || key, plaintext, p, rp).replace(/,/g, ",\n");
    return ctJson;
  }

  static doDecrypt(password, jsonCt) {
    var rp = {};
    var p = {};
    if (jsonCt.length === 0) {
      return "";
    }
    if (!password) {
      return "";
    }
    var plaintext;
    if (jsonCt.match("{")) {
      try {
        plaintext = sjcl.decrypt(password, jsonCt, p, rp);
        return plaintext;
      } catch (e) {
        return "error";
      }
    } else {
      return "error";
    }
  }
}
